import { render, staticRenderFns } from "./Zsgg.vue?vue&type=template&id=a3fb4486&scoped=true"
import script from "./Zsgg.vue?vue&type=script&lang=js"
export * from "./Zsgg.vue?vue&type=script&lang=js"
import style0 from "./Zsgg.vue?vue&type=style&index=0&id=a3fb4486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fb4486",
  null
  
)

export default component.exports